import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";

interface Props {
  permission?: PermissionsEnums | PermissionsEnums[];
  requireAll?: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function PermissionCheck({
  permission,
  requireAll = false,
  children,
  fallback,
}: Props) {
  const { checkPermission } = usePermissionCheck();

  if (!checkPermission(permission, requireAll)) return fallback || null;

  return <>{children}</>;
}
